import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("label", null, "Object", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("label", null, "Status", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("label", null, "Contactpersoon", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("label", null, "Telefoonnummer contactpersoon", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("label", null, "E-mailadres contactpersoon", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("label", null, "Onderwerp", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("label", null, "Omschrijving", -1)
const _hoisted_8 = ["innerHTML"]
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", null, "Afbeeldingen", -1)

import { onMounted, ref } from 'vue'
import { useRoute } from 'vue-router'
import axios from 'axios'
import { Question } from '@/types/Question'
import Banner from '@/components/Banner.vue'
import Filelist from '@/components/Filelist.vue'
import Comments from '@/components/service/Comments.vue'
import NewComment from '@/components/service/NewComment.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'QuestionShow',
  setup(__props) {

const route = useRoute()
const question = ref<Question|null>(null)

onMounted(() => {
  getQuestion()
})

function getQuestion () : void {
  axios.get(process.env.VUE_APP_API_URL + '/questions/' + route.params.questionId).then((r) => {
    question.value = r.data
    if (question.value && question.value.comments) {
      question.value.comments = question.value.comments.reverse()
    }
  })
}

return (_ctx: any,_cache: any) => {
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_divider = _resolveComponent("a-divider")!
  const _component_a_card = _resolveComponent("a-card")!

  return (_openBlock(), _createBlock(_component_a_row, { gutter: [16,16] }, {
    default: _withCtx(() => [
      _createVNode(_component_a_col, { span: 24 }, {
        default: _withCtx(() => [
          _createVNode(_component_a_card, {
            title: `Vraag #${_unref(route).params.questionId}`,
            bordered: false,
            loading: !question.value
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_row, { gutter: [32,32] }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_col, {
                    span: 24,
                    xl: 12
                  }, {
                    default: _withCtx(() => [
                      _hoisted_1,
                      _createElementVNode("p", null, _toDisplayString(question.value.building.address) + " " + _toDisplayString(question.value.building.zipcode) + " " + _toDisplayString(question.value.building.city), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_a_row, { gutter: [32,32] }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_col, {
                    span: 24,
                    xl: 12
                  }, {
                    default: _withCtx(() => [
                      _hoisted_2,
                      _createElementVNode("p", null, _toDisplayString(question.value.status_label), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_a_divider),
              _createVNode(_component_a_row, { gutter: [32,32] }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_col, {
                    span: 24,
                    xl: 12
                  }, {
                    default: _withCtx(() => [
                      _hoisted_3,
                      _createElementVNode("p", null, _toDisplayString(question.value.contact_name), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_a_row, { gutter: [32,32] }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_col, {
                    span: 24,
                    xl: 12
                  }, {
                    default: _withCtx(() => [
                      _hoisted_4,
                      _createElementVNode("p", null, _toDisplayString(question.value.contact_phone), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_col, {
                    span: 24,
                    xl: 12
                  }, {
                    default: _withCtx(() => [
                      _hoisted_5,
                      _createElementVNode("p", null, _toDisplayString(question.value.contact_email), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_a_divider),
              _createVNode(_component_a_row, { gutter: [32,32] }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_col, {
                    span: 24,
                    xl: 12
                  }, {
                    default: _withCtx(() => [
                      _hoisted_6,
                      _createElementVNode("p", null, _toDisplayString(question.value.title), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_a_row, { gutter: [32,32] }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_col, {
                    span: 24,
                    xl: 24
                  }, {
                    default: _withCtx(() => [
                      _hoisted_7,
                      _createElementVNode("div", {
                        innerHTML: question.value.description
                      }, null, 8, _hoisted_8)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              (question.value && question.value.files.length)
                ? (_openBlock(), _createBlock(_component_a_row, {
                    key: 0,
                    gutter: [32,32]
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_col, {
                        span: 24,
                        xl: 24
                      }, {
                        default: _withCtx(() => [
                          _hoisted_9,
                          _createVNode(Filelist, {
                            "media-items": question.value.files
                          }, null, 8, ["media-items"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["title", "loading"]),
          _createVNode(_component_a_card, {
            title: "Berichten",
            style: {"margin-top":"16px"},
            bordered: false,
            loading: !question.value
          }, {
            default: _withCtx(() => [
              _createVNode(NewComment, {
                "model-type": "question",
                "model-id": _unref(route).params.questionId,
                onCommentCreated: getQuestion
              }, null, 8, ["model-id"]),
              (question.value && question.value.comments.length)
                ? (_openBlock(), _createBlock(Comments, {
                    key: 0,
                    comments: question.value.comments
                  }, null, 8, ["comments"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["loading"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})